import { toast } from '@tviklax/ui-components';

export const showToast = (message: string, type: 'success' | 'error' | 'info' = 'success') => {
  const variants = {
    success: 'default' as const,
    error: 'destructive' as const,
    info: 'default' as const,
  };

  const icons = {
    success: '✓',
    error: '⚠',
    info: 'ℹ',
  };

  toast({
    title: `${icons[type]} ${type.charAt(0).toUpperCase() + type.slice(1)}`,
    description: message,
    variant: variants[type],
  });
};
